export default "__VITE_ASSET__eeba6a30__"